import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "dialog-footer" }

import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import { useStore } from '@/store'
import Pagination from '@/components/Pagination.vue'
import { getComplaintOrderListApi, saveComplaintOrderApi, getOrderDetailApi } from '@/apis/merchant-admin'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'


export default /*@__PURE__*/_defineComponent({
  __name: 'ComplaintOrderList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()

const filters = reactive({
    username: '',
    order_id: '',
    sale_channel: '',
    problem: '',
    page: 1,
    page_size: 10,
})

const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getComplaintOrderListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    tableData.value = data.data
    total.value = data.total
}

/************************ 添加弹框 -- begin ************************/
const addDialogShow = ref(false)
const emptyRow = reactive({
    old_order_id: '', // 记录原值，用于判断订单ID是否有更新
    order_id: '',
    username: '',
    sale_channel: '',
    brand_name: '',
    product_name: '',
    problem: '',
    scheme: '',
}) // 空行
const newList = ref([JSON.parse(JSON.stringify((emptyRow)))])
const onAdd = () => {
    newList.value.push(JSON.parse(JSON.stringify((emptyRow))))
}
const getOrderDetail = async (order_id, index) => {
    // 如果有值且与原值相同则不进行任何操作
    if (newList.value[index].order_id && newList.value[index].order_id === newList.value[index].old_order_id) {
        return
    }
    // 如何没有值视为清空数据
    if (!order_id) {
        newList.value[index] = JSON.parse(JSON.stringify((emptyRow)))
        return
    }
    // 如果有重复值进行提示并清空当前行数据
    const repeatLen = newList.value.filter(item => item.order_id === order_id).length
    if (repeatLen > 1) {
        newList.value[index] = JSON.parse(JSON.stringify((emptyRow)))
        return proxy.$message({ type: 'error', message: '订单ID重复'})
    }
    const { code, data, msg } = await getOrderDetailApi(order_id) as any
    // 如果接口报错进行错误提示，同时清空当前行数据 3539479066650 3556030899543
    if (code != 200) {
        newList.value[index] = JSON.parse(JSON.stringify((emptyRow)))
        newList.value[index].old_order_id = order_id
        newList.value[index].order_id = order_id
        return proxy.$message({ type: 'error', message: msg })
    }

    data.old_order_id = data.order_id
    newList.value[index] = data
}
const addDialogClose = () => {
    newList.value = [JSON.parse(JSON.stringify((emptyRow)))]
    addDialogShow.value = false
}
const onSave = async () => {
    const errorIndex = newList.value.findIndex(item => item.order_id && (!item.problem || !item.scheme))
    if (errorIndex > -1) {
        return proxy.$message({ type: 'error', message: `第 ${errorIndex+1} 行请添加问题描述及解决方法`})
    }
    // 过滤到空行
    newList.value = newList.value.filter(item => item.order_id)

    const { code, msg } = await saveComplaintOrderApi (newList.value) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    proxy.$message({ type: 'success', message: '保存成功' })
    addDialogClose()
    getList()
}
/************************ 添加弹框 -- end ************************/

/************************ 批量添加弹框 -- begin ************************/
const batchDialogShow = ref(false)
const onUpload = () => {
    // if (!proxy.$refs.upload.value) {
    //     return proxy.$message({ type: 'error', message: '请选择文件' })
    // }
    proxy.$refs.upload.submit()
}
const onUploadSuccess = async (res) => {
    const {code, msg} = res
    if (code != 200) {
        proxy.$refs.upload.clearFiles()
        return proxy.$message({ type: 'error', message: msg })
    }

    proxy.$message({ type: 'success', message: '上传成功' })
    batchDialogClose()
    getList()
}
const onExceed = () => {
    proxy.$message({ type: 'error', message: '只允许上传一个文件' })
}
const batchDialogClose = () => {
    proxy.$refs.upload.clearFiles()
    batchDialogShow.value = false
}
/************************ 批量添加弹框 -- begin ************************/

const onExport = () => {
    window.open(`${Keys.baseUrl}/help/get_help_order_list?${joinParams({...filters, user_id: store.state.user.userInfo.id })}&export_type=1`)
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onMounted(() => {
    getList() 
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          class: "filter-item",
          modelValue: filters.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.username) = $event)),
          placeholder: "输入用户名",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          class: "filter-item",
          modelValue: filters.order_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.order_id) = $event)),
          placeholder: "输入订单ID",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          class: "filter-item",
          modelValue: filters.sale_channel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.sale_channel) = $event)),
          placeholder: "输入销售渠道",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          class: "filter-item",
          modelValue: filters.problem,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.problem) = $event)),
          placeholder: "输入问题",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          class: "filter-btn",
          type: "primary",
          onClick: onSearch
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("搜索")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "filter-btn",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (addDialogShow.value = true))
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("添加")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "filter-btn",
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (batchDialogShow.value = true))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("批量上传")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "filter-btn",
          type: "primary",
          onClick: onExport
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("导出")
          ])),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: tableData.value,
        stripe: "",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "order_id",
            label: "订单ID"
          }),
          _createVNode(_component_el_table_column, {
            prop: "username",
            label: "用户名"
          }),
          _createVNode(_component_el_table_column, {
            prop: "sale_channel",
            label: "销售渠道"
          }),
          _createVNode(_component_el_table_column, {
            prop: "brand_name",
            label: "品牌"
          }),
          _createVNode(_component_el_table_column, {
            prop: "product_name",
            label: "商品名称及规格"
          }),
          _createVNode(_component_el_table_column, {
            prop: "problem",
            label: "问题"
          }),
          _createVNode(_component_el_table_column, {
            prop: "scheme",
            label: "解决方法"
          }),
          _createVNode(_component_el_table_column, {
            prop: "add_time",
            label: "创建时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "admin_name",
            label: "操作人"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        currentPage: filters.page,
        total: total.value,
        onPageChange: onPageChange,
        onSizeChange: onSizeChange
      }, null, 8, ["currentPage", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "添加投诉",
      modelValue: addDialogShow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addDialogShow).value = $event)),
      "before-close": addDialogClose,
      width: "90%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: addDialogClose }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onSave
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("保 存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: newList.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "订单ID",
              width: "150"
            }, {
              default: _withCtx(({ row, $index }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.order_id,
                  "onUpdate:modelValue": ($event: any) => ((row.order_id) = $event),
                  modelModifiers: { trim: true },
                  placeholder: "输入订单ID",
                  onBlur: ($event: any) => (getOrderDetail(row.order_id, $index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "用户名",
              prop: "username"
            }),
            _createVNode(_component_el_table_column, {
              label: "销售渠道",
              prop: "sale_channel"
            }),
            _createVNode(_component_el_table_column, {
              label: "品牌",
              prop: "brand_name"
            }),
            _createVNode(_component_el_table_column, {
              label: "商品名称及规格",
              width: "300"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.product_name,
                  "onUpdate:modelValue": ($event: any) => ((row.product_name) = $event),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  placeholder: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "问题",
              width: "300"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.problem,
                  "onUpdate:modelValue": ($event: any) => ((row.problem) = $event),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  placeholder: "输入问题"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "解决方法",
              width: "300"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.scheme,
                  "onUpdate:modelValue": ($event: any) => ((row.scheme) = $event),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  placeholder: "输入解决方法"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_row, {
          class: "mt10",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: onAdd
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("添加")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量上传",
      modelValue: batchDialogShow.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((batchDialogShow).value = $event)),
      "before-close": batchDialogClose,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: batchDialogClose }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onUpload
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "upload",
                  action: `/api/help/add_help_order_all?user_id=${_unref(store).state.user.userInfo.id}&user_name=${_unref(store).state.user.userInfo.username}`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "auto-upload": false,
                  limit: 1,
                  "on-exceed": onExceed
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_unref(Keys).baseUrl}/help/down_help_template`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("下载批量添加模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})